// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folders_toast-module__link--2pRhb{color:#fff;text-decoration:underline;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word}\n", ""]);
// Exports
exports.locals = {
	"link": "folders_toast-module__link--2pRhb"
};
module.exports = exports;
